import isEmail from 'validator/lib/isEmail';
import isAlpha from 'validator/lib/isAlpha';
import isAlphanumeric from 'validator/lib/isAlphanumeric';
// import isStrongPassword from 'validator/lib/isStrongPassword'
import isNumeric from 'validator/lib/isNumeric';

const regExpPhone = /^[0-9]*$/;
// meta to Z einai ta ellinika https://stackoverflow.com/questions/50320061/how-can-i-validate-greek-characters-in-javascript
const regExpForeignPhone = /[a-zA-Z\u0370-\u03FF\u1F00-\u1FFF]/;
// const regExpPassword = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/g
const regExpPassword = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
// const regExpPassword = new RegExp("^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$")

export const checkEmail = email => {
	if (typeof email !== 'string') {
		return false;
	} else {
		return isEmail(email);
	}
};

export const checkAlphanumeric = input => {
	const usrName = input.replace(/\s/g, '');
	if (!usrName || usrName.length === 0) return false;
	return isAlphanumeric(usrName, 'en-US') || isAlphanumeric(usrName, 'el-GR');
};

// an epitrepoume kena thelei trim (asxeta me to validation)
export const checkName = input => {
	if (typeof input !== 'string') {
		return false;
	} else {
		const inputFormatted = input.replace(/\s/g, '');
		if (!inputFormatted || inputFormatted.length === 0) return false;

		if (isAlpha(inputFormatted, 'en-US') || isAlpha(inputFormatted, 'el-GR')) {
			return true;
		} else {
			return false;
		}
	}
};

export const checkPhone = input => {
	return !!input && input.length === 10 && regExpPhone.test(input);
};

export const checkPhoneSoft = input => {
	let inputModified = input;
	if (input?.length === 13 && input?.startsWith('+30')) {
		inputModified = inputModified.substring(3, input.length);
	} else if (input?.length === 12 && input?.startsWith('30')) {
		inputModified = inputModified.substring(2, input.length);
	}

	// console.log(input.length, regExpPhone.test(input))
	return inputModified?.length === 10 && regExpPhone.test(inputModified);
};

export const checkForeignPhone = input => {
	// console.log(input.length, regExpPhone.test(input))
	return !!input && input.length > 4 && input.length < 16 && !regExpForeignPhone.test(input);
};

export const checkPassword = input => {
	// return regExpPassword.test(input)
	// const res = regExpPassword.test(input)
	// console.log('regExpPassword', input, res)
	return regExpPassword.test(input);
	// return !!input && isStrongPassword(input)
};

export const isNumericFee = str => {
	if (typeof str != 'string') return false; // we only process strings!
	return (
		!isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
		!isNaN(parseFloat(str))
	); // ...and ensure strings of whitespace fail
};

export const checkNumber = input => {
	// console.log("check n ", input);
	return !!input && (isNumeric(input, 'en-US') || isNumeric(input, 'el-GR'));
};

export const checkTime = time => {
	const spaceSplit = time.split(' ');
	const dotSplit = time.split(':');
	// console.log("splits: ", spaceSplit, " ", dotSplit);
	// if ((spaceSplit && dotSplit) || (!spaceSplit && !dotSplit)) {
	//   console.log(":: 1");
	//   return false;
	// }

	const split =
		spaceSplit?.length === 2 ? spaceSplit : dotSplit?.length === 2 ? dotSplit : spaceSplit;

	// length checking

	if (split.length !== 1 && split.length !== 2) {
		// console.log(":: 2", split.length);
		return false;
	}

	// string checking

	if (split[0].length > 2) {
		// console.log(":: 3", split[0].length);
		return false;
	}
	if (split[1]) {
		if (split[1].length > 2) {
			// console.log(":: 4");
			return false;
		}
	}

	// number checking

	const numberCheck = (number, type) => {
		const num = parseInt(number);
		// console.log("num ", num);

		// parseInt returns NaN for non-numeric input. 0 is a valid hour (midnight),
		// so this must be a NaN check and not a falsy check.
		if (Number.isNaN(num)) {
			return false;
		}

		// Compare the parsed number, not the raw string, so that non-numeric
		// input cannot slip through the range comparisons.
		if (type === 'hours') {
			if (num < 0 || num > 23) {
				return false;
			}
		} else if (type === 'minutes') {
			if (num < 0 || num > 59) {
				return false;
			}
		}

		// console.log("numberCheck true");

		return true;
	};

	if (!numberCheck(split[0], 'hours') || (!split[1] ? false : !numberCheck(split[1], 'minutes'))) {
		// console.log(":: 5");
		return false;
	}

	return {
		hours: split[0],
		minutes: split[1],
	};
};

// Canonical "HH:mm" for an opening-hours field, or null when the input is not a
// valid time. checkTime deliberately accepts loose input ("9:30", "9 30", "9"),
// but those forms are not valid ISO times, so whatever reads the stored window
// later cannot parse them — store the padded form instead.
export const normalizeTime = time => {
	const checked = checkTime(time ?? '');

	if (!checked) {
		return null;
	}

	const hours = String(parseInt(checked.hours, 10)).padStart(2, '0');
	const minutes = String(parseInt(checked.minutes ?? '0', 10)).padStart(2, '0');

	return `${hours}:${minutes}`;
};

// {
//   days: [
//     {
//       day: 28,
//       month: 11,
//       year: 2022,
//       hourRanges: [
//         {
//           from: 4,
//           to: 5,
//           deliveriesInfo: [
//             {
//               id: 51,
//               name: "xaris",
//               orders: [...orders],
//             },
//           ],
//         },
//       ],
//     },
//   ];
// }
